import React from 'react'
import {
  FlowLabel,
  LabelCloseWrapper,
  StyledCloseButton,
  NavigationWrapper,
} from './component.styles'
import BackLink from './BackLink'
import PropTypes from 'prop-types'

const ModalHeader = ({
  flowLabel,
  handleCancel,
  handleClose,
  handleGoBack,
  showBackButton = true,
}) => {
  return (
    <NavigationWrapper>
      <div>
        {showBackButton && <BackLink onClick={handleGoBack}>Back</BackLink>}
      </div>
      <LabelCloseWrapper>
        {flowLabel && <FlowLabel>{flowLabel}</FlowLabel>}
        <StyledCloseButton
          dataTestId="modal-close-button"
          onClick={handleCancel || handleClose}
        />
      </LabelCloseWrapper>
    </NavigationWrapper>
  )
}

ModalHeader.propTypes = {
  flowLabel: PropTypes.string,
  handleCancel: PropTypes.func,
  handleClose: PropTypes.func.isRequired,
  handleGoBack: PropTypes.func.isRequired,
  showBackButton: PropTypes.bool,
}

export default ModalHeader
